/** Full locale fr – edit as needed. */
export default {
  'nav.home': 'Accueil',
  'nav.seeDemo': 'Voir la démo',
  'nav.howItWorks': 'Comment ça marche',
  'nav.pricing': 'Tarifs',
  'nav.aboutUs': 'À propos',
  'nav.faqs': 'FAQ',
  'nav.contact': 'Contact',
  'nav.careers': 'Carrières',
  'nav.blog': 'Blog',
  'nav.logIn': 'Connexion / Inscription',
  'nav.getStarted': 'Commencer',
  'brand.primeDocumentSign': 'Prime Document Sign',
  'hero.priceBanner': 'À partir de 2 $/mois !',
  'hero.subscriptionsOnly': '( Abonnements uniquement )',
  'hero.couponBannerText': 'Code promo 10 % de réduction à vie pour nos 1000 premiers utilisateurs !',
  'hero.couponSubscribedOnly': '(abonnés uniquement)',
  'hero.couponCode': '25OFFNEWUSERS1000',
  'hero.bannerEyebrow': 'Plateforme de e-signature · Forfaits dès 2 $/mois',
  'hero.bannerHeadlinePrefix': 'Obtenez des',
  'hero.bannerHeadlineMid': 'signés',
  'hero.bannerHeadlineAccent': 'instantanément.',
  'hero.bannerCycleContracts': 'contrats',
  'hero.bannerCycleNDAs': 'NDA',
  'hero.bannerCycleProposals': 'propositions',
  'hero.bannerCycleDocuments': 'documents',
  'hero.bannerDesc':
    'Créez des accords professionnels, envoyez-les en signature électronique et recevez des PDF signés juridiquement contraignants — en quelques minutes, sur tout appareil.',
  'hero.firebaseTopAria': 'Sécurité et hébergement (Google Firebase et Google Cloud)',
  'hero.topTrustListAria': 'Sécurité, tarifs, signature, rappels et support',
  'hero.accDataSafeTitle': 'Vos données sont en sécurité chez nous',
  'hero.accDataSafe1':
    'Alimenté par Google Firebase et Google Cloud — la même infrastructure de niveau entreprise utilisée par des millions d’applications',
  'hero.accDataSafe2':
    'Vos données sont protégées par chiffrement AES-256 au repos avec des clés gérées par Google',
  'hero.accDataSafe3':
    'Authentification et traitement des données selon les standards de sécurité de Google',
  'hero.accDataSafe4': 'Nous ne vendons ni ne partageons vos données — votre vie privée est respectée',
  'hero.accDataSafe5Before': 'Transparence sur le stockage et l’utilisation (voir notre ',
  'hero.accDataSafe5After': ')',
  'hero.accPricingTitle': 'Tarification simple — sans frais cachés',
  'hero.accPricing1': 'Créez des accords professionnels en quelques minutes',
  'hero.accPricing2': 'Forfaits dès seulement 2 $ par mois',
  'hero.accPricing3': 'Pas de frais cachés ni de surprises',
  'hero.accPricing4': 'Sans engagement — résiliez quand vous voulez',
  'hero.accPricing5': 'Idéal pour freelances, startups et PME',
  'hero.accPricing6': 'Envoyez votre premier document gratuitement',
  'hero.accSigningTitle': 'Signature rapide et simple',
  'hero.accSigning1': 'Plus de 30 modèles prêts ou votre propre fichier',
  'hero.accSigning2': 'Ajoutez des champs de signature et personnalisez en secondes',
  'hero.accSigning3': 'Envoyez à plusieurs destinataires à la fois',
  'hero.accSigning4': 'Enregistrez des modèles réutilisables',
  'hero.accSigning5': 'Les signataires n’ont pas besoin de compte — signature immédiate',
  'hero.accSigning6': 'Aperçu en direct avant envoi',
  'hero.accRemindersTitle': 'Rappels intelligents et suivi',
  'hero.accReminders1': 'Rappels automatiques à 1, 3 et 7 jours',
  'hero.accReminders2': 'Notifications à l’ouverture ou à la signature',
  'hero.accReminders3': 'Suivez le parcours de signature en temps réel',
  'hero.accReminders4': 'Ne relancez plus manuellement',
  'hero.accAnywhereTitle': 'Travaillez de n’importe où',
  'hero.accAnywhere1': 'Accédez à vos documents sur ordinateur ou mobile',
  'hero.accAnywhere2': 'Envoyez et signez sur tout appareil',
  'hero.accAnywhere3': 'Conçu pour la flexibilité — bureau ou déplacement',
  'hero.accSupportTitle': 'Support fiable',
  'hero.accSupport1': 'Support client dédié et réponses rapides',
  'hero.accSupport2': 'Objectif : réponse sous 24 h',
  'hero.accSupport3': 'Mises à jour continues selon vos retours',
  'hero.firebaseTrustPrivacyLink': 'Politique de confidentialité',
  'hero.firebaseTrustFineprintAfter':
    ' explique la conservation, l’accès et vos droits. Nous ne vendons jamais vos données.',
  'hero.pill': 'Envoyez des signatures électroniques juridiquement contraignantes en quelques secondes',
  'hero.headline': 'L\'outil de signature électronique le plus simple pour les freelances et les petites équipes',
  'hero.watchDemo': 'Voir la démo',
  'hero.trustLocked': 'Chiffrement AES-256',
  'hero.trustNoCard': 'Sans carte bancaire',
  'hero.trustReady': 'Opérationnel en 2 min',
  'hero.landingShowMore': 'Afficher plus',
  'hero.landingShowLess': 'Afficher moins',
  'hero.tagline': 'Le moyen le plus simple de créer, signer et envoyer des documents — sans engagement',
  'hero.ctaPrimary': 'Créer / Télécharger un document et envoyer pour signature',
  'hero.ctaTrialSignup': 'Démarrer l’essai gratuit',
  'hero.ctaFreeDocument': 'Démarrer l’essai gratuit',
  'hero.ctaPrimaryNote': '7 jours gratuits. Carte requise. Puis 35 $/an sauf annulation.',
  'hero.subscriptionTeaserBefore': 'Abonnements à partir de seulement ',
  'hero.subscriptionTeaserAfter': ' par mois !',
  'hero.createAccountTrialHeadline': 'Démarrez votre essai gratuit de 7 jours',
  'hero.createAccountPromoCopy': 'Copier le code',
  'hero.createAccountPromoCopied': 'Copié !',
  'hero.createAccountPromoCodeAria': 'Code promo : un mois d’essai gratuit',
  'hero.createAccountNote': 'Utilisez-le au paiement lorsque vous choisissez une offre.',
  'hero.createAccountOfferLimit': '( Offre valable pour nos 1000 premiers utilisateurs uniquement )',
  'hero.desc': 'Créez, envoyez et suivez les accords avec une expérience de signature moderne.',
  'hero.getStartedFree': 'Commencer gratuitement',
  'hero.tryWithoutAccountButton': 'Essayer sans compte',
  'hero.logInSignUp': 'Connexion / Inscription',
  'hero.whyChooseUs': 'Pourquoi nous ?',
  'hero.stepsTitle': 'Créer, Signer, Recevoir',
  'hero.stepsSubtitle': 'Trois étapes simples pour créer et faire signer vos documents en quelques minutes.',
  'hero.step1Create': 'Téléchargez ou créez votre document',
  'hero.step2Sign': 'Envoyez-le pour signature',
  'hero.step3Receive': 'Soyez notifié instantanément une fois signé',
  'hero.benefit1': 'Simple – Envoyez des liens et e-mails de signature en quelques secondes',
  'hero.benefit2': 'Télécharger un PDF existant ou extraire le texte et modifier avec l’éditeur de texte',
  'hero.benefit3': 'Extraire le texte du PDF et modifier',
  'hero.benefit4': 'Créer champs et mises en page en quelques secondes',
  'hero.benefit5': 'Envoyer à plusieurs destinataires en même temps',
  'hero.benefit7': 'Copier le lien et envoyer à qui vous voulez',
  'hero.benefit8': 'Créer et enregistrer des modèles',
  'hero.benefit9': 'Voir tous les événements e-mail',
  'hero.benefit10': 'Aperçu en direct et PDFs conformes',
  'hero.benefit11': 'Modèles avec édition flexible',
  'hero.benefit12': 'Les destinataires n\'ont pas besoin de compte',
  'hero.benefit13': 'Fonctionne sur tous les appareils',
  'how.simpleProcess': 'Processus simple',
  'how.title': 'Comment ça marche',
  'how.subtitle': 'Créez, envoyez et signez en trois étapes.',
  'how.step1Title': 'Créer un modèle',
  'how.step1Desc': 'Extraire ou télécharger PDF, éditeur de texte, champs de signature (date, nom, conditions, blocs de signature), mise en page. Enregistrer comme modèle et réutiliser.',
  'how.step2Title': 'Envoyer aux destinataires',
  'how.step2Desc': 'Envoyez des documents par e-mail avec des liens de signature uniques et sécurisés. Plusieurs destinataires, copier les liens, suivre les ouvertures et signatures.',
  'how.step3Title': 'Recevoir les PDF signés',
  'how.step3Desc': 'Recevez des PDF signés avec piste d\'audit : date, e-mail, téléphone, consentement. E-mail de confirmation à la fin.',
  'pricing.compareHeadline': 'Pourquoi payer 19 $/mois pour les signatures électroniques ?',
  'pricing.comparePlatform': 'Plateforme',
  'pricing.comparePrice': 'Prix',
  'pricing.compareUs': 'Prime Document Sign',
  'pricing.compareDocuSign': 'DocuSign',
  'pricing.compareDropboxSign': 'Dropbox Sign',
  'pricing.comparePandaDoc': 'PandaDoc',
  'pricing.comparePerMonth': '{price}/mois',
  'pricing.compareBestValue': 'Meilleur rapport qualité-prix',
  'pricing.compareWhyPayLine1': 'Envoyez des signatures électroniques juridiquement contraignantes en quelques secondes',
  'pricing.compareWhyPayLine2': 'Plus d\'un envoi ? Abonnements à partir de 2 $ par mois',
  'pricing.compareBenefitSingle': 'Envoyez des documents à l\'unité',
  'pricing.compareBenefitNoContract': 'Pas de contrats onéreux',
  'pricing.compareBenefitPayWhenNeed': 'Payez seulement quand vous en avez besoin',
  'pricing.compareBenefitTemplates': 'Choisissez parmi plus de 30 modèles',
  'pricing.compareDisclaimer': 'Prix concurrents basés sur les offres de démarrage publiques ; peuvent varier.',
  'trust.secureLinks': 'Liens de signature uniques et sécurisés pour chaque document',
  'trust.auditTrail': 'Piste d\'audit complète sur chaque signature (qui, quand, IP)',
  'trust.verifiablePdfs': 'PDF signés vérifiables que vous pouvez conserver',
  'trust.footer': 'Approuvé par les freelances et les petites entreprises du monde entier',
  'useCases.title': 'Parfait pour ( Modèles prêts )',
  'useCases.freelancers': 'Freelances qui envoient des contrats',
  'useCases.agencies': 'Agences qui signent des accords',
  'useCases.landlords': 'Propriétaires qui envoient des baux',
  'useCases.startups': 'Startups qui signent des NDA',
  'useCases.carBoat': 'Vendre une voiture ou un bateau avec un document légal',
  'useCases.consultants': 'Consultants et indépendants',
  'useCases.equipmentRental': 'Louer du matériel avec un accord formel',
  'useCases.contractors': 'Prestataires indépendants formalisant des mandats',
  'useCases.website': 'Accords de projets web et numériques',
  'pricing.title': 'Tarifs',
  'pricing.billAnnually': 'Facturation annuelle',
  'pricing.billMonthly': 'Facturation mensuelle',
  'pricing.getStarted': 'Commencer',
  'pricing.mostPopular': 'LE PLUS POPULAIRE',
  'pricing.billedPerYear': '${amount}/an',
  'pricing.perMonth': '/mois',
  'pricing.tierBasic': 'Basique',
  'pricing.tierStandard': 'Standard',
  'pricing.tierPremium': 'Premium',
  'pricing.descBasic': 'Pour usage occasionnel.',
  'pricing.descStandard': 'Pour équipes en croissance.',
  'pricing.descPremium': 'Pour utilisateurs avancés.',
  'about.label': 'Pourquoi nous',
  'about.title': 'À propos',
  'about.subtitle': 'Nous rendons les flux de signature simples, rapides et sécurisés.',
  'about.speed': 'Rapidité',
  'about.builtForSpeed': 'Conçu pour la rapidité',
  'about.builtForSpeedDesc': 'Interface moderne : créez et envoyez des documents en quelques minutes. Signature depuis tout appareil.',
  'about.security': 'Sécurité',
  'about.dataSecurity': 'Sécurité des données',
  'about.dataSecurityTitle': 'Hébergé sur Google Firebase et Google Cloud',
  'about.dataSecurityDesc': 'Les données de votre compte, documents, modèles et activité de signature sont traitées sur Google Firebase et Google Cloud, des plateformes conçues pour les applications en production nécessitant une authentification et un stockage robustes. Le trafic utilise HTTPS (TLS) de bout en bout ; les données au repos sont chiffrées avec des clés gérées par Google (dont AES-256). Les connexions passent par Firebase Authentication, et les règles de sécurité Firestore aident à garantir que les lectures et écritures correspondent à votre compte, afin que votre espace de travail reste isolé et ne soit pas lisible par tout Internet. La pile s\'exécute sur le réseau mondial de Google (« monitoring », correctifs, durabilité) comme décrit dans la documentation Google, et nous ne vendons pas vos données personnelles ni le contenu de vos documents à des intermédiaires ou annonceurs. Pour les sous-traitants, la conformité et vos droits, voir notre Politique de confidentialité.',
  'about.dataSecurityPrivacyCta': 'Lire la Politique de confidentialité complète →',
  'about.privacyPill': 'Confidentialité',
  'about.privacyFocused': 'Respect de la vie privée',
  'about.privacyFocusedDesc': 'Chaque lien de signature est unique : les destinataires ne voient que ce que vous leur envoyez. Les PDF signés comportent une piste d\'audit claire à archiver : qui a signé, quand et le consentement donné, pour que confidentialité et preuve aillent ensemble.',
  'about.teams': 'Particuliers et équipes',
  'about.madeForTeams': 'Pour particuliers et équipes',
  'about.madeForTeamsDesc': 'Modèles pour tous : texte, titres, listes, champs de signature, date, nom, champs personnalisés. Enregistrez et réutilisez les modèles.',
  'about.sectionHeadlineBefore': 'Conçu pour la ',
  'about.sectionHeadlineAccent': 'confiance et la rapidité',
  'about.firebaseVisualBadge': 'Google Firebase · Google Cloud',
  'faq.title': 'FAQ',
  'faq.searchHint': 'Recherchez par mot-clé pour trouver rapidement des FAQ',
  'faq.searchPlaceholder': 'ex. PDF, modèle, signature...',
  'faq.noResults': 'Aucune FAQ ne correspond à votre recherche. Essayez d\'autres mots-clés.',
  'faq.more': 'Plus',
  'faq.less': 'Moins',
  'faq.eyebrow': 'Des questions ?',
  'faq.titleBefore': 'Questions ',
  'faq.titleAccent': 'fréquentes',
  'faq.subtitleLead': 'Tout savoir sur Prime Document Sign. Vous ne trouvez pas la réponse ? ',
  'faq.subtitleLink': 'Contactez-nous.',
  'faq.clearSearchAria': 'Effacer la recherche',
  'faq.subscriptionsWorkQ': 'Comment fonctionnent les abonnements ?',
  'faq.upgradePlanQ': 'Comment améliorer mon plan ?',
  'faq.upgradePlanA': 'Mon compte → Mon abonnement, choisir un palier supérieur et confirmer. Mise à niveau en général immédiate.',
  'faq.downgradePlanQ': 'Comment rétrograder ?',
  'faq.downgradePlanA': 'Mon compte → Mon abonnement, choisir un palier inférieur. Effet au début du prochain cycle.',
  'faq.cancelPlanQ': 'Comment annuler mon abonnement ?',
  'faq.cancelPlanA': 'Mon compte → Mon abonnement, annuler via le portail Stripe ou contacter le support. Annulation en fin de période.',
  'faq.emailLimitQ': 'Que se passe-t-il quand j\'atteins la limite d\'e-mails ?',
  'faq.emailLimitA': 'Basique : 5 e-mails/mois, Standard : 100, Premium : 300. Limite réinitialisée chaque mois. À la limite : acheter plus ou améliorer.',
  'faq.yearlyBillingQ': 'Facturation annuelle ?',
  'faq.yearlyBillingA': 'Oui. Premium : ${{monthly}} $/mois ou ${{annual}} $/an. L\'annuel économise jusqu\'à {{discountPercent}}%. Changer dans Mon abonnement.',
  'faq.multipleRecipientsQ': 'Plusieurs destinataires ?',
  'faq.multipleRecipientsA': 'Oui. Basique : jusqu\'à 5, Standard et Premium : jusqu\'à 10. E-mails séparés par des virgules. Chacun reçoit un lien unique. Pas de compte requis.',
  'faq.reuseTemplatesQ': 'Réutiliser les modèles ?',
  'faq.reuseTemplatesA': 'Basique : 3, Standard : 10, Premium : 25 modèles. Historique des modèles (Mon compte) pour charger les modèles.',
  'faq.recipientAccountQ': 'Le destinataire a-t-il besoin d\'un compte ?',
  'faq.recipientAccountA': 'Non. Le destinataire reçoit l\'e-mail avec le lien et peut signer depuis son appareil. Pas de compte. Bureau, tablette, mobile.',
  'faq.confirmationEmailQ': 'E-mail de confirmation ?',
  'faq.confirmationEmailA': 'Oui. À la fin, e-mail avec PDF signé. Chaque PDF inclut la piste d\'audit.',
  'faq.previewPdfQ': 'Aperçu PDF avant envoi ?',
  'faq.previewPdfA': 'Oui. Bouton Aperçu PDF pour voir la mise en page. Puis envoyer ou copier le lien.',
  'faq.editAgreementQ': 'Modifier le texte de l\'accord ?',
  'faq.editAgreementA': 'Oui. Éditeur de texte pour titres, listes, gras, italique, souligné. Télécharger un PDF pour extraire ou afficher.',
  'faq.signatureRequiredQ': 'Signature obligatoire ?',
  'faq.signatureRequiredA': 'Oui. Les destinataires doivent remplir date, nom, case conditions et signature. Exigences légales.',
  'faq.attachmentsQ': 'Combien de pièces jointes ?',
  'faq.attachmentsA': 'Basique : aucune. Standard : 3 (8 Mo total). Premium : 10 (8 Mo total). Envoyées avec le lien de signature.',
  'faq.emailActivityQ': 'Activité e-mail (Premium) ?',
  'faq.emailActivityA': 'Premium : Activité e-mail dans Mon compte. Quels documents, quand, à qui. Conformité.',
  'faq.emailRemindersQ': 'Comment fonctionnent les rappels par e-mail ?',
  'faq.emailRemindersA': 'Dans le créateur de documents, étape 4 (Fonctions supplémentaires), vous pouvez activer des rappels à 1, 3 et/ou 7 jours pour chaque envoi. Après le premier e-mail de signature, nous n\'envoyons un rappel que si le destinataire n\'a pas encore terminé le document. Les rappels s\'arrêtent automatiquement lors de la signature. Les e-mails de rappel figurent dans l\'activité e-mail avec date et heure ; ils ne comptent pas dans votre quota mensuel d\'envois.',
  'faq.defaultSenderQ': 'E-mail d\'expéditeur par défaut ?',
  'faq.defaultSenderA': 'Mon compte → Détails du compte, saisir l\'e-mail et enregistrer. Rempli automatiquement à l\'envoi.',
  'faq.mobileSignQ': 'Signer sur mobile ?',
  'faq.mobileSignA': 'Oui. Expérience responsive. Ouvrir le lien sur smartphone ou tablette, signer au doigt ou au stylet.',
  'faq.getHelpQ': 'Comment obtenir de l\'aide ?',
  'faq.getHelpA': 'Support dans Mon compte ou formulaire de contact. Nous répondons dès que possible.',
  'faq.dataSecureQ': 'Mes données sont-elles sécurisées ?',
  'faq.dataSecureA': 'Oui. Pratiques standard pour protéger vos documents et informations.',
  'faq.fileFormatsQ': 'Quels formats de fichier ?',
  'faq.fileFormatsA': 'Documents créés dans l\'éditeur de texte. Accords finaux en PDF.',
  'faq.deleteTemplateQ': 'Que se passe-t-il si je supprime un modèle ?',
  'faq.deleteTemplateA': 'Les modèles supprimés sont définitifs. Vérifier avant de supprimer. Créer un nouveau modèle à tout moment.',
  'faq.ownLogoQ': 'Puis-je ajouter mon logo ?',
  'faq.ownLogoA': 'Oui, sur les plans Standard et Premium. Télécharger le logo (jusqu\'à 20 Ko) et choisir la position. Basique non inclus.',
  'faq.uploadPdfQ': 'Comment télécharger un PDF ?',
  'faq.uploadPdfA': 'Dans le créateur de documents, utilisez l\'option Télécharger un PDF (plans Standard et Premium). Votre PDF s\'affiche au-dessus ou à côté du texte. Les destinataires voient le document complet lors de la signature.',
  'faq.extractPdfQ': 'Qu\'est-ce que l\'extraction PDF et comment ça marche ?',
  'faq.extractPdfA': 'L\'extraction PDF (Standard et Premium) permet d\'extraire le texte d\'un PDF existant dans l\'éditeur pour le modifier. Téléchargez votre PDF, choisissez Extraire le texte, et le contenu est copié. Vous pouvez ensuite le modifier et ajouter des champs de signature.',
  'faq.richTextEditorQ': 'Que puis-je faire avec l\'éditeur de texte enrichi ?',
  'faq.richTextEditorA': 'L\'éditeur permet de créer et formater des accords : titres, gras, italique, listes, tailles de police. Ajoutez des blocs de signature en dessous. Tout en point-and-click.',
  'faq.previewWhenQ': 'Quand prévisualiser avant d\'envoyer ?',
  'faq.previewWhenA': 'Utilisez toujours Aperçu PDF avant d\'envoyer. Il affiche la mise en page exacte : texte, blocs de signature, date, nom. Vérifiez le formatage puis envoyez.',
  'faq.documentLifetimeQ': 'Combien de temps les liens de signature restent-ils actifs ? Extension possible ?',
  'faq.documentLifetimeA': 'Les liens restent actifs environ 30 jours. Téléchargez et sauvegardez votre PDF signé avant expiration. Si un lien a expiré, contactez l\'expéditeur pour en demander un nouveau.',
  'faq.editLayoutQ': 'Comment modifier la disposition des signatures ?',
  'faq.editLayoutA': 'Utilisez Modifier la disposition dans la section signature pour réorganiser les champs. Glissez-déposez date, nom, conditions, signatures et champs personnalisés. Ajoutez des espaceurs et choisissez le nombre de colonnes.',
  'faq.customFieldsQ': 'Comment ajouter des champs personnalisés (texte, date, case à cocher, etc.) ?',
  'faq.customFieldsA': 'Cliquez sur Ajouter un champ personnalisé. Choisissez un libellé et un type : Texte, Nombre, Date, Heure, Liste, Case à cocher ou Signature. Jusqu\'à 10 champs par document. Indiquez quels signataires voient chaque champ, puis utilisez Modifier la disposition.',
  'faq.multipleSignaturesQ': 'Puis-je ajouter 2 signatures ou plus (plusieurs signataires) ?',
  'faq.multipleSignaturesA': 'Oui. Utilisez la section Destinataires pour ajouter un second signataire. Chacun reçoit un lien unique et son propre bloc de signature. Jusqu\'à 5 (Básique) ou 10 (Standard/Premium) destinataires par envoi.',
  'faq.documentBuilderTipsQ': 'Que puis-je faire dans le créateur de documents ?',
  'faq.documentBuilderTipsA': 'Créer des accords, télécharger ou extraire des PDFs, ajouter des blocs de signature, champs personnalisés et pièces jointes. Modifier la disposition, sauvegarder des modèles, prévisualiser. Tout se sauvegarde automatiquement.',
  'faq.clearEverythingQ': 'Que fait Effacer tout ?',
  'faq.clearEverythingA': 'Effacer tout réinitialise le créateur : texte, blocs de signature, champs personnalisés et pièces jointes. Utilisez-le pour repartir de zéro. Vos modèles sauvegardés ne sont pas affectés.',
  'faq.forgotPasswordQ': 'J\'ai oublié mon mot de passe. Comment le réinitialiser ?',
  'faq.forgotPasswordA': 'Sur l\'écran de connexion, cliquez sur Mot de passe oubli ? Saisissez l\'e-mail de votre compte et envoyez le lien. Vérifiez votre boîte (et spam). Le lien expire rapidement—demandez-en un nouveau si besoin. Connectez-vous avec le nouveau mot de passe.',
  'faq.saveTemplateQ': 'Comment sauvegarder un document comme modèle ?',
  'faq.saveTemplateA': 'Créez votre document, puis cliquez sur Sauvegarder le modèle. Donnez-lui un nom et cliquez sur Sauvegarder comme nouveau. Il apparaît dans Historique des modèles (Mon compte). Pour mettre à jour : chargez le modèle, modifiez, puis Sauvegarder le modèle → Mettre à jour le modèle.',
  'faq.loadTemplateQ': 'Comment charger un modèle depuis l\'historique ?',
  'faq.loadTemplateA': 'Allez dans Mon compte → Historique des modèles. Cliquez sur le modèle à charger. Il s\'ouvre dans le créateur avec tout le contenu et la mise en page. Modifiez si besoin, ajoutez les destinataires et envoyez.',
  'faq.templateLimitsQ': 'Combien de modèles puis-je sauvegarder ?',
  'faq.templateLimitsA': 'Basique : 3, Standard : 10, Premium : 25 modèles. Chaque modèle stocke le texte, le formatage, les blocs de signature et la disposition. À la limite : supprimez un ancien ou améliorez votre plan.',
  'faq.recipientNoEmailQ': 'Le destinataire n\'a pas reçu l\'e-mail de signature ?',
  'faq.recipientNoEmailA': 'Demandez-lui de vérifier les spams. Sinon, utilisez Copier le lien pour obtenir l\'URL et partagez-la manuellement (SMS, Slack, etc.). Vous pouvez aussi renvoyer le document à la même adresse pour un nouveau lien.',
  'faq.editAfterSendQ': 'Puis-je modifier un document après l\'avoir envoyé ?',
  'faq.editAfterSendA': 'Non. Une fois envoyé, le contenu est verrouillé. Pour modifier : créez un nouveau document avec les changements et renvoyez-le. Les brouillons non envoyés peuvent être modifiés librement.',
  'faq.changeAccountQ': 'Comment modifier mon e-mail ou mot de passe ?',
  'faq.changeAccountA': 'Mon compte → Détails du compte. Mettez à jour l\'e-mail ou le mot de passe. Pour le mot de passe : saisissez l\'actuel puis le nouveau. Utilisez Mot de passe oubli ? si vous ne vous souvenez pas de l\'actuel.',
  'faq.browserSupportQ': 'Quels navigateurs et appareils sont supportés ?',
  'faq.browserSupportA': 'Chrome, Firefox, Safari, Edge (desktop et mobile). L\'expérience de signature est responsive—smartphones et tablettes. Utilisez les versions récentes pour de meilleures performances. Aucune application à télécharger.',
  'faq.copyLinkQ': 'Comment copier un lien pour partager au lieu d\'envoyer par e-mail ?',
  'faq.copyLinkA': 'Après avoir créé le document, cliquez sur Copier le lien. L\'URL est copiée. Collez-la dans un message, e-mail ou Slack. Le destinataire peut signer sans recevoir d\'e-mail de notre part.',
  'faq.resendDocumentQ': 'Puis-je renvoyer un document si le destinataire n\'a pas signé ?',
  'faq.resendDocumentA': 'Oui. Envoyez à nouveau le même document ou à une autre adresse. Chaque envoi crée un nouveau lien. Si le lien original a expiré, le renvoi donne un lien frais. Utilisez Activité e-mail (Premium) pour suivre les envois.',
  'testimonials.eyebrow': 'TÉMOIGNAGES',
  'testimonials.title': 'Ce que disent nos clients.',
  'testimonials.quote1': 'Le coût est le plus bas. Meilleur rapport qualité-prix et simple à utiliser.',
  'testimonials.quote2': 'Accord collé depuis ChatGPT, modifié en quelques minutes, envoyé pour signature. Fait en moins de 10 minutes.',
  'testimonials.quote3': 'Tout depuis mon téléphone. Document créé, champs de signature ajoutés, envoyé en déplacement.',
  'testimonials.quote4': 'Simple et tarifs justes. Pas de frais cachés. Mon équipe l\'utilise pour contrats et NDA.',
  'testimonials.quote5': 'Texte du contrat collé, blocs de signature ajoutés, envoyé. Signé le même jour.',
  'testimonials.quote6': 'Sur ordinateur et téléphone. Expérience fluide. Meilleure valeur pour la signature électronique.',
  'testimonials.prev': 'Précédent',
  'testimonials.next': 'Suivant',
  'contact.title': 'Contactez-nous',
  'contact.subtitle': 'Des questions ? Nous serions ravis de vous lire.',
  'contact.eyebrow': 'Contactez-nous',
  'contact.headlineBefore': 'Parlons ',
  'contact.headlineAccent': 'ensemble',
  'contact.responseTimeLabel': 'Délai de réponse',
  'contact.responseTimeValue': 'Sous 24 heures',
  'contact.secureLabel': 'Sécurisé et privé',
  'contact.secureValue': 'Chiffrement AES-256',
  'contact.trustNoSpam': 'Jamais de spam',
  'contact.trustHumanSupport': 'Vrais humains au support',
  'contact.firstName': 'Prénom',
  'contact.lastName': 'Nom',
  'contact.email': 'E-mail',
  'contact.message': 'Message',
  'contact.sendMessage': 'Envoyer',
  'contact.required': '*',
  'contact.placeholderFirst': 'Votre prénom',
  'contact.placeholderLast': 'Votre nom',
  'contact.placeholderEmail': 'Votre e-mail',
  'contact.placeholderMessage': 'Dites-nous comment nous aider…',
  'contact.attachments': 'Pièces jointes',
  'contact.attachmentsHint': 'Jusqu\'à 5 fichiers, 2 Mo total',
  'contact.addFiles': '+ Ajouter des fichiers',
  'contact.addAttachmentsAria': 'Ajouter des pièces jointes',
  'auth.forgotPassword': 'Mot de passe oublié ?',
  'auth.backToLogIn': 'Retour à la connexion',
  'auth.sendResetLink': 'Envoyer le lien de réinitialisation',
  'auth.checkEmailReset': 'Vérifiez votre e-mail pour le lien.',
  'auth.emailLabel': 'E-mail',
  'auth.passwordLabel': 'Mot de passe',
  'auth.firstNameLabel': 'Prénom',
  'auth.lastNameLabel': 'Nom',
  'auth.enterEmail': 'Saisissez votre e-mail.',
  'auth.enterEmailPassword': 'Saisissez e-mail et mot de passe.',
  'auth.passwordMinLength': 'Le mot de passe doit contenir au moins 8 caractères.',
  'auth.passwordSpecial': 'Le mot de passe doit contenir un caractère spécial.',
  'auth.passwordsNoMatch': 'Les mots de passe ne correspondent pas.',
  'auth.signInWithGoogle': 'Se connecter avec Google',
  'auth.or': 'ou',
  'auth.logInFailed': 'Échec de la connexion.',
  'auth.signUpFailed': 'Échec de l\'inscription.',
  'auth.emailAlreadyInUse': 'Cette adresse e-mail est déjà utilisée.',
  'connectionError.message': 'Problème de connexion. Vérifiez votre connexion internet et actualisez la page.',
  'connectionError.refresh': 'Actualiser la page',
  'connectionError.tooManyRequests': 'Trop de tentatives. Réessayez plus tard.',
  'auth.emailPlaceholder': 'jean@exemple.fr',
  'auth.passwordPlaceholder': 'Entrez votre mot de passe',
  'auth.firstNamePlaceholder': 'Jean',
  'auth.lastNamePlaceholder': 'Dupont',
  'auth.manageSubscription': 'Gérer l\'abonnement',
  'auth.subscribe': 'S\'abonner',
  'auth.signUpForSubscription': 'S\'inscrire pour l\'abonnement',
  'auth.currentPlan': 'PLAN ACTUEL',
  'auth.updatePlanHint': 'Mettez à jour votre plan dans Stripe pour plus de crédits mensuels.',
  'auth.updatePlanStripe': 'Mettre à jour le plan, le paiement ou annuler dans le portail Stripe.',
  'auth.subscribeToPlan': 'Abonnez-vous à un plan pour commencer.',
  'auth.topUpCredits': 'Acheter des crédits ({{label}} : ${{price}})',
  'pricing.featureRecipients5': 'Jusqu\'à 5 destinataires par envoi',
  'pricing.featureRecipients10': 'Jusqu\'à 10 destinataires par envoi',
  'pricing.featureEmails5': 'Max 5 e-mails/mois',
  'pricing.featureEmails50': 'Max 100 e-mails/mois',
  'pricing.featureEmails150': 'Max 300 e-mails/mois',
  'pricing.featureTemplates3': '3 modèles',
  'pricing.featureTemplates10': '10 modèles',
  'pricing.featureTemplates25': '25 modèles',
  'pricing.featureChars3k': 'Limite 3 000 caractères',
  'pricing.featureChars20k': 'Limite 20 000 caractères',
  'pricing.featureChars30k': 'Limite 30 000 caractères',
  'pricing.featureAttachmentsNone': 'Pas de pièces jointes',
  'pricing.featureAttachments3': '3 pièces jointes (8 Mo)',
  'pricing.featureAttachments10': '10 pièces jointes (8 Mo)',
  'pricing.featurePdfUpload': 'Téléchargement PDF complet',
  'pricing.featureAuditTrail': 'Piste d\'audit complète',
  'pricing.featurePdfExtract': 'Extraire et modifier le texte PDF',
  'pricing.featureCustomFields': 'Créer des champs et modifier la mise en page',
  'pricing.featureCopyLink': 'Copier le lien pour signer',
  'pricing.featureLogo': 'Télécharger un logo',
  'pricing.featureVerification': 'Vérification du destinataire',
  'app.createYourDocument': 'Créer votre document',
  'app.backToApp': 'Retour à l\'app',
  'app.backToMainSite': 'Retour au site',
  'app.backShort': 'Retour',
  'app.myAccount': 'Mon compte',
  'app.saveTemplate': 'Enregistrer le modèle',
  'app.templatesUsed': 'Modèles utilisés',
  'app.templatesUsedSaved': '{{count}} modèles enregistrés',
  'app.startFromTemplate': 'Commencer à partir d\'un modèle',
  'app.startFromTemplateHint': 'Choisissez un modèle pour remplir le document. Vous pouvez le modifier après sélection.',
  'app.signedInAs': 'Connecté en tant que',
  'app.sendCredits': 'Crédits d\'envoi',
  'app.freeSendBanner': 'Vous avez 1 envoi d’e-mail gratuit — utilisez-le pour envoyer votre document à signer. Abonnez-vous quand vous voulez pour en envoyer plus.',
  'app.creditEqualsSend': '1 crédit = 1 envoi par e-mail',
  'app.topUpCredits': 'Acheter des crédits',
  'app.emailSends': 'envois par e-mail',
  'app.signedAgreements': 'accords signés',
  'app.usedAfterAllowance': '(utilisés après le forfait mensuel)',
  'app.sendForSignature': 'Envoyer pour signature',
  'app.recipientsSection': 'Envoyer à',
  'app.fromNameOrg': 'Nom / Organisation de l\'expéditeur',
  'app.fromNamePlaceholder': 'Votre nom ou organisation',
  'app.fromEmail': 'E-mail de l\'expéditeur',
  'app.fromEmailPlaceholder': 'Adresse e-mail de l\'expéditeur',
  'app.recipientEmail': 'E-mail du destinataire',
  'app.recipientHint': 'Séparés par des virgules, jusqu\'à {{max}} destinataire(s)',
  'app.recipientPlaceholder': 'Adresse e-mail du destinataire',
  'app.recipientTooltip': 'Exemple : a@b.com, c@d.com, e@f.com',
  'app.previewPdf': 'Aperçu PDF',
  'app.clearEverything': 'Tout effacer',
  'app.clearEverythingTitle': 'Effacer le document, les destinataires et le brouillon enregistré',
  'app.copyLink': 'Copier le lien',
  'app.copyLinkSubscribersOnly': 'Copier le lien (abonnés uniquement)',
  'app.generatingLink': 'Génération du lien…',
  'app.sendEmail': 'Envoyer l\'e-mail',
  'app.agreementText': 'Texte de l\'accord',
  'app.uploadPdfExtract': 'Télécharger un PDF pour extraire le texte',
  'app.fullPdfUpload': 'Télécharger un PDF complet',
  'app.agreementPlaceholder': 'Cliquez ici pour commencer et rédiger le texte de l\'accord…',
  'app.attachments': 'Pièces jointes',
  'app.attachmentsHint': 'Jusqu\'à 10 fichiers, 8 Mo max au total pour la livraison par e-mail.',
  'app.addAttachment': '+ Ajouter une pièce jointe',
  'app.signatureSection': 'Section signature',
  'app.totalSignatures': 'Nombre de signatures',
  'app.createNewField': 'Créer un nouveau champ',
  'app.addField': 'Ajouter un champ',
  'app.layout': 'Mise en page',
  'app.editLayout': 'Modifier la mise en page',
  'app.addFieldTooltip': 'Ajoutez un champ personnalisé (texte, date, case à cocher ou signature) au bloc de signature. Jusqu\'à {{max}} champs personnalisés.',
  'app.date': 'Date',
  'app.datePlaceholder': 'aaaa/mm/jj',
  'app.termsConditions': 'Termes et conditions',
  'app.fullName': 'Nom complet',
  'app.fullNamePlaceholder': 'Saisissez le nom complet',
  'app.signature': 'Signature',
  'app.clickToSign': 'Cliquez pour signer',
  'app.termsAgree': 'J\'accepte tous les termes et conditions.',
  'app.phone': 'Téléphone',
  'app.phonePlaceholder': 'Saisissez le numéro de téléphone',
  'app.enterFieldPlaceholder': 'Saisir {{label}}',
  'app.enterNumber': 'Saisir un nombre',
  'app.selectOption': 'Sélectionner...',
  'app.noFields': 'Aucun champ',
  'app.newDocument': 'Nouveau document',
  'app.templateLabel': 'Modèle : {{name}}',
  'app.forSubscribersOnly': 'Réservé aux abonnés',
  'app.emailCredits': 'Crédits e-mail',
  'app.creditHintDeliver': '1 crédit = 1 envoi — cliquez sur Envoyer pour livrer',
  'app.skipAuthTesting': 'Ignorer l\'auth (test)',
  'app.agreementRequired': 'Le texte de l\'accord ou un PDF est requis.',
  'app.agreementOrPdfRequired': 'Le texte de l\'accord ou un document PDF est requis.',
  'app.loadingPdf': 'Chargement du PDF…',
  'app.clearConfirmTitle': 'Tout effacer',
  'app.clearConfirmMessage': 'Voulez-vous vraiment effacer tous les champs et pièces jointes ?',
  'app.cancel': 'Annuler',
  'app.clear': 'Effacer',
  'app.clearConfirmButton': 'Oui, tout effacer',
  'footer.tagline': 'Signature électronique sécurisée pour les utilisateurs modernes.',
  'footer.product': 'Produit',
  'footer.templates': 'Modèles',
  'footer.company': 'Entreprise',
  'footer.contactSupport': 'Support',
  'footer.copyright': '© 2026 primedocumentsign. Tous droits réservés.',
  'footer.terms': 'Conditions d\'utilisation',
  'footer.privacy': 'Politique de confidentialité',
  'auth.logIn': 'Connexion',
  'auth.loggingIn': 'Connexion…',
  'auth.getStarted': 'Commencer',
  'auth.signUp': 'S\'inscrire',
  'auth.logInToManage': 'Connectez-vous pour gérer et envoyer des documents à signer.',
  'auth.startSending': 'Commencez à envoyer des documents avec un plan d\'abonnement simple.',
  'auth.termsConfirmStart': 'Je confirme avoir lu et accepté les',
  'auth.termsConfirmEnd': '.',
  'auth.termsMustAccept': 'Veuillez accepter les conditions d\'utilisation pour créer un compte.',
  'email.signSubject': 'Veuillez signer cet accord',
  'email.signTitle': 'Document à signer',
  'email.signSubtitle': 'On vous a demandé de signer un document',
  'email.fromLabel': 'De',
  'email.signBody': 'Cliquez sur le bouton ci-dessous pour ouvrir le document et ajouter votre signature. Tout destinataire peut utiliser ce lien pour accéder et signer — aucun compte ni abonnement requis.',
  'email.signButton': 'Signer le document',
  'email.copyLink': 'Ou copiez ce lien :',
  'email.ignoreNote': 'Si vous n\'attendiez pas cet e-mail, vous pouvez l\'ignorer.',
  'modal.editFieldLayout': 'Modifier la mise en page des champs',
  'modal.editFieldLayoutHint': 'Glissez les champs pour les réordonner ou les déplacer entre les colonnes.',
  'modal.columns': 'Colonnes',
  'modal.col': '{{n}} col',
  'modal.addSpace': '+ Ajouter un espace',
  'modal.fields': 'Champs',
  'modal.leftColumn': 'Colonne gauche',
  'modal.rightColumn': 'Colonne droite',
  'modal.removeFromLayout': 'Retirer {{name}} de la mise en page ?',
  'modal.space': 'espace',
  'modal.yesRemove': 'Oui, retirer',
  'modal.keepIt': 'Garder',
  'modal.emptySpace': 'Espace vide',
  'modal.dropFieldsHere': 'Déposez les champs ici',
  'modal.removedFromLayout': 'Retiré de la mise en page — cliquez sur + pour restaurer',
  'modal.saveLayout': 'Enregistrer la mise en page',
  'modal.removeFromLayoutTitle': 'Retirer de la mise en page',
  'modal.restoreToLayout': 'Restaurer dans la mise en page',
  'modal.editCustomField': 'Modifier le champ personnalisé',
  'modal.editCustomFieldHint': 'Modifiez l\'étiquette, le type ou les signataires qui voient ce champ.',
  'modal.addCustomField': 'Ajouter un champ personnalisé',
  'modal.addCustomFieldHint': 'Créez un nouveau champ pour le formulaire de signature. Max. 10 champs personnalisés.',
  'modal.fieldLabel': 'Étiquette du champ',
  'modal.fieldLabelPlaceholder': 'ex. Nom de l\'entreprise',
  'modal.fieldType': 'Type de champ',
  'modal.displayContent': 'Contenu affiché (lecture seule pour le destinataire, max 100 car.)',
  'modal.displayContentPlaceholder': 'ex. Veuillez consulter les termes ci-dessous',
  'modal.picklistOptions': 'Options de la liste (max 10)',
  'modal.typeAndPressAdd': 'Saisissez et appuyez sur Ajouter',
  'modal.add': 'Ajouter',
  'modal.addedToSignature': 'Ajouté à la signature',
  'modal.addedToSignatureHint': 'Cochez les cases ci-dessous pour ajouter le nouveau champ au layout de signature',
  'modal.signature1': 'Signature 1',
  'modal.signature2': 'Signature 2',
  'modal.close': 'Fermer',
  'modal.save': 'Enregistrer',
  'modal.fieldLabelRequired': 'L\'étiquette du champ est obligatoire',
  'modal.displayContentRequired': 'Le contenu affiché est obligatoire pour l\'affichage texte',
  'modal.picklistOptionRequired': 'Ajoutez au moins une option à la liste',
  'modal.selectOneSignature': 'Sélectionnez au moins une signature',
  'modal.signingSectionExceed': 'La section signature dépasserait la limite de {{limit}} Ko. Supprimez du contenu d\'abord.',
  'modal.link': 'Lien',
  'modal.linkTitle': 'Titre du lien',
  'modal.linkUrl': 'URL du lien',
  'modal.linkTextPlaceholder': 'Texte du lien',
  'modal.linkUrlPlaceholder': 'https://exemple.com',
  'modal.agreementSizeLimitReached': 'Limite de taille de l\'accord atteinte',
  'modal.characterLimitReached': 'Limite de caractères atteinte',
  'modal.agreementSizeLimitMessage': 'Vous avez atteint la taille maximale de l\'accord ({{max}} Ko). Supprimez du contenu ou des images avant d\'en ajouter.',
  'modal.characterLimitMessage': 'Vous avez atteint la limite de caractères ({{max}}). Supprimez du texte avant d\'en ajouter.',
  'modal.signingSectionLimitReached': 'Limite de la section signature atteinte',
  'modal.signingSectionLimitMessage': 'Vous avez atteint la taille maximale de la section signature ({{limit}} Ko). Supprimez des valeurs, signatures ou champs avant d\'en ajouter.',
  'modal.ok': 'OK',
  'modal.addYourSignature': 'Ajouter votre signature',
  'modal.signatureHint': 'Utilisez la souris ou le pavé tactile pour signer.',
  'modal.clear': 'Effacer',
  'modal.saveSignature': 'Enregistrer la signature',
  'modal.removeAttachment': 'Supprimer la pièce jointe',
  'modal.removeAttachmentConfirm': 'Voulez-vous vraiment supprimer « {{name}} » de ce document ?',
  'modal.yesRemoveLabel': 'Oui, supprimer',
  'modal.removeLogo': 'Supprimer le logo',
  'modal.removeLogoConfirm': 'Voulez-vous vraiment supprimer votre logo de ce document ?',
  'modal.textDisplay': 'Texte à afficher',
  'modal.picklist': 'Liste de choix',
  'modal.number': 'Nombre',
  'modal.time': 'Heure',
  'modal.editLabel': 'Modifier l\'étiquette',
  'modal.editField': 'Modifier le champ',
  'modal.text': 'Texte',
  'modal.checkbox': 'Case à cocher',
  'modal.date': 'Date',
  'modal.signature': 'Signature',
  'modal.typeHasDataHint': 'Le type ne peut pas être modifié car ce champ contient déjà des données.',
  'modal.typeHasDataTitle': 'Le type ne peut pas être modifié lorsque le champ contient des données',
  'modal.noKeepIt': 'Non, garder',
  'modal.yesDelete': 'Oui, supprimer',
  'modal.deleteTemplate': 'Supprimer le modèle',
  'modal.deleteTemplateConfirm': 'Voulez-vous vraiment supprimer « {{name}} » ? Cette action est irréversible.',
  'modal.removeAttachmentFromMessage': 'Voulez-vous vraiment supprimer « {{name}} » de votre message ?',
  'modal.readyToSend': 'Prêt à envoyer ?',
  'modal.recipientsLabel': 'Destinataire(s) :',
  'modal.readyToSendSubtitle': 'Avez-vous prévisualisé votre document et êtes-vous prêt à l\'envoyer ? Le(s) destinataire(s) suivant(s) recevront cet e-mail :',
  'modal.readyToSendNote': 'Lors du téléchargement d\'un PDF - La signature peut être coupée si l\'espacement correct n\'est pas appliqué. Veuillez vérifier et ajuster si nécessaire avant d\'envoyer.',
  'modal.no': 'Non',
  'modal.yesSend': 'Oui, envoyer',
  'modal.accountAlreadyExists': 'Compte déjà existant',
  'modal.accountAlreadyExistsMessage': 'Cet e-mail est déjà enregistré. Voulez-vous vous connecter ou créer un compte avec un autre e-mail ?',
  'modal.useDifferentEmail': 'Utiliser un autre e-mail',
  'modal.logIn': 'Connexion',
  'modal.logOut': 'Déconnexion ?',
  'modal.logOutSubtitle': 'Voulez-vous vraiment vous déconnecter ?',
  'modal.yesLogOut': 'Oui, se déconnecter',
  'lang.en': 'Anglais',
  'lang.es': 'Espagnol',
  'lang.pt': 'Portugais',
  'lang.ja': 'Japonais',
  'lang.zh': 'Chinois',
  'lang.hi': 'Hindi',
  'lang.fr': 'Français',
  'lang.it': 'Italien',
  'lang.de': 'Allemand',

  'templates.starter.nda.name': 'Accord de confidentialité (NDA)',
  'templates.starter.nda.scopeTitle': 'Accord de confidentialité',
  'templates.starter.freelance.name': 'Contrat de prestation freelance',
  'templates.starter.freelance.scopeTitle': 'Contrat de prestation freelance',
  'templates.starter.vehicle.name': 'Contrat de vente de véhicule',
  'templates.starter.vehicle.scopeTitle': 'Contrat de vente de véhicule',
  'templates.starter.rental.name': 'Contrat de location résidentielle',
  'templates.starter.rental.scopeTitle': 'Contrat de location résidentielle',
  'templates.starter.recruitment.name': 'Contrat de services de recrutement',
  'templates.starter.recruitment.scopeTitle': 'Contrat de services de recrutement',
  'templates.starter.loan.name': 'Accord de prêt',
  'templates.starter.loan.scopeTitle': 'Accord de prêt',
  'templates.starter.website.name': 'Accord de développement de site web',
  'templates.starter.website.scopeTitle': 'Accord de développement de site web',
  'templates.starter.roommate.name': 'Accord de colocation',
  'templates.starter.roommate.scopeTitle': 'Accord de colocation',
  'templates.starter.photography.name': 'Accord de services photographiques',
  'templates.starter.photography.scopeTitle': 'Accord de services photographiques',
  'templates.starter.shortterm-rental.name': 'Accord de location courte durée',
  'templates.starter.shortterm-rental.scopeTitle': 'Accord de location courte durée',
  'templates.starter.equipment-rental.name': 'Accord de location d\'équipement',
  'templates.starter.equipment-rental.scopeTitle': 'Accord de location d\'équipement',
  'templates.starter.independent-contractor.name': 'Accord de sous-traitant indépendant',
  'templates.starter.independent-contractor.scopeTitle': 'Accord de sous-traitant indépendant',
}
